import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';

import { CbButtonModule } from '@chubb/ui-components';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-policy-not-found',
  imports: [CbButtonModule],
  templateUrl: './policy-not-found.component.html',
  styleUrl: './policy-not-found.component.scss',
})
export class PolicyNotFoundComponent {
  protected readonly _location: Location = inject(Location);
  back() {
    this._location.back();
  }

  getSupport() {
    const supportUrl = environment.supportUrl;
    window.location.href = supportUrl;
  }
}
